import React from "react";
import { Link } from "react-router-dom";
import Card from "./Card";
import { dashboardItems } from "constants/data";
import {
  FiTrendingUp,
  FiCheckSquare,
  FiUsers,
  FiBarChart2,
  FiCpu,
  FiSliders,
  FiArrowRight,
  FiActivity,
} from "react-icons/fi";
import { FaNewspaper } from "react-icons/fa";

const ICON_MAP = {
  predictions: <FiTrendingUp size={22} />,
  promises: <FiCheckSquare size={22} />,
  predictors: <FiUsers size={22} />,
  surveys: <FiBarChart2 size={22} />,
};

const QUICK_MODULES = [
  {
    title: "AI Ավտոմատացումներ",
    description: "Կառավարեք ինքնաշխատ սկանավորման և վերլուծության գործընթացները",
    path: "/automations",
    icon: FiCpu,
    badge: "AI Powered",
  },
  {
    title: "Լրահոս և Սկաներ",
    description: "Դիտեք վերջին 7 օրերի սկանավորված լուրերը և ավելացրեք նորերը",
    path: "/news",
    icon: FaNewspaper,
    badge: "Real-time",
  },
  {
    title: "Գլխավոր էջի կարգավորում",
    description: "Ընտրեք և կարգավորեք հավելվածի գլխավոր էջում ցուցադրվող նյութերը",
    path: "/main",
    icon: FiSliders,
    badge: "Curated",
  },
];

const DashboardItems = ({ lengths = {} }) => {
  return (
    <div className="w-full min-h-screen bg-slate-50 p-6 sm:p-8 lg:p-10 overflow-y-auto">
      <div className="max-w-7xl mx-auto space-y-8">
        {/* Executive Header */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pb-6 border-b border-slate-200/80">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="p-2.5 rounded-xl bg-indigo-50 text-indigo-600 border border-indigo-100/80 shadow-xs">
                <FiActivity size={22} />
              </span>
              <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">
                Գլխավոր վահանակ
              </h1>
            </div>
            <p className="text-xs sm:text-sm text-slate-500 mt-1 ml-11">
              Համակարգի ամփոփ վիճակագրություն և կառավարման կենտրոն
            </p>
          </div>

          <div className="flex items-center gap-2 self-start sm:self-auto">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200">
              <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
              Համակարգն ակտիվ է
            </span>
          </div>
        </div>

        {/* 1. Main KPI Stat Cards */}
        <div>
          <h2 className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-4">
            Հիմնական ցուցանիշներ
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {dashboardItems.map(({ slug, name, path }) => (
              <Card
                key={slug}
                title={name}
                icon={ICON_MAP[slug]}
                path={path}
                number={lengths[slug] || 0}
              />
            ))}
          </div>
        </div>

        {/* 2. Quick Modules & Administration Shortcuts */}
        <div>
          <h2 className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-4">
            Արագ կառավարման մոդուլներ
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {QUICK_MODULES.map((mod) => {
              const Icon = mod.icon;
              return (
                <Link
                  key={mod.path}
                  to={mod.path}
                  className="bg-white border border-slate-200/80 hover:border-indigo-300 rounded-2xl p-5 shadow-xs hover:shadow-md transition-all duration-200 group flex flex-col justify-between"
                >
                  <div>
                    <div className="flex items-center justify-between gap-3 mb-3">
                      <div className="p-2.5 rounded-xl bg-slate-100 text-slate-700 group-hover:bg-indigo-600 group-hover:text-white transition-colors duration-200">
                        <Icon size={18} />
                      </div>
                      <span className="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-slate-100 text-slate-600 border border-slate-200/60">
                        {mod.badge}
                      </span>
                    </div>
                    <h3 className="text-sm font-bold text-slate-900 group-hover:text-indigo-600 transition-colors">
                      {mod.title}
                    </h3>
                    <p className="text-xs text-slate-500 mt-1 leading-relaxed">
                      {mod.description}
                    </p>
                  </div>

                  <div className="pt-4 mt-4 border-t border-slate-100 flex items-center justify-between text-xs font-semibold text-slate-600 group-hover:text-indigo-600 transition-colors">
                    <span>Բացել մոդուլը</span>
                    <FiArrowRight
                      size={14}
                      className="group-hover:translate-x-1 transition-transform duration-200"
                    />
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardItems;
